import { useContext } from "react";
import axios from "@fetch/axios"
import { useTranslation } from "@hooks/useTranslation";
import { LanguageCurrencyContext } from "@context/LanguageCurrencyContext";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const Component = () => {
  const MySwal = withReactContent(Swal)
  const { translate } = useTranslation();
  const { lang } = useContext(LanguageCurrencyContext);
  const email = localStorage.getItem('email_crear');

  const reenviar = async () => {

    const token = localStorage.getItem('token_volver_crear');

    try {

      const res = await axios.put(
        "/users/resend-confirmation",
        {
          "token": token,
          "lang": lang
        }
      );

      if (res.data.errors) {

        MySwal.fire({
          text: res.data.message,
          icon: 'error',
          title: 'Oops...'
        })

      } else {
        localStorage.setItem('token_volver_crear', res.data.token)

        MySwal.fire({
          text: translate('login.resend'),
          icon: 'success',
        })

      }
    } catch (error) {

      MySwal.fire({
        text: error.response.data,
        icon: 'error',
        title: 'Oops...'
      })

    }

  }

  return (
    <>
      <div className="icon-Mail IconLarge"></div>
      <div className="TextLeft">
        <p>
          {translate('confirmation.send1')} {email}, {translate('confirmation.send2')}
        </p>
        <p>
          {translate('confirmation.send3')}
        </p>
      </div>
      <div>
        <p>{translate('confirmation.send4')} </p>
        <p><b onClick={reenviar} style={{ cursor: 'pointer' }}>{translate('confirmation.send5')}</b></p>
      </div>
    </>
  );
};

export default Component;
